import { ReactNode } from "react"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import Dialog from "@components/Dialog"

export interface ConfirmDialogProps {
  open: boolean
  dialogTitle: string
  children?: ReactNode
  onClose: (value: boolean) => void
}

export default function ConfirmDialog({
  open,
  dialogTitle,
  children,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      title={dialogTitle}
      actionsComponent={
        <DialogActions>
          <Button onClick={() => onClose(false)} color="error" variant="contained">
            Cancel
          </Button>
          <Button onClick={() => onClose(true)} variant="contained">
            Yes
          </Button>
        </DialogActions>
      }
    >
      {children}
    </Dialog>
  )
}
